import React from "react";
import styles from "./styles.module.css"
import {useNavigate} from "react-router-dom";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import {HeaderButtons} from "./HeaderButtons/HeaderButtons";
import {useFetchRecommsBySector} from "../../../hooks/useQuery/useFetchRecommsBySector";
import NewRecommendationCard from "./NewRecommendationCard";
import {Administrator} from "../../../services/models/administrator";
import {SubUser} from "../../../services/models/sub_user";
import isAdministrator from "../../../Utils/isAdmin";
import {useFetchSubUsersBySector} from "../../../hooks/useQuery/useFetchSubUsersBySector";
import {BreadcrumbItem} from "../../../components/shared/NewBreadcrumbs/NewBreadcrumbs";
import {Recommendation} from "../../../services/models/recommendation";

interface SectorsPageViewProps {
    sectorId: string,
    user: Administrator | SubUser | null
}

const RecommendationsPageView: React.FC<SectorsPageViewProps> = ({sectorId, user}) => {
    const {recommsSectorData, recommsSectorError, recommsSectorIsLoading} = useFetchRecommsBySector(sectorId);
    const {subUsersSectorData, subUsersSectorError, subUsersSectorIsLoading} = useFetchSubUsersBySector(sectorId);
    const [searchValue, setSearchValue] = React.useState<string>('');

    let navigate = useNavigate();

    const goToRecommendations = (id: string) => {
        let path = `${id}`;
        navigate(path);
    };
    const isLoading = recommsSectorIsLoading || subUsersSectorIsLoading;
    const isError = !!(recommsSectorError || subUsersSectorError);

    // Фильтруем рекомендации по поисковому запросу
    const filteredRecommendations = React.useMemo(() => {
        if (!recommsSectorData) return [];
        if (!searchValue.trim()) return recommsSectorData;
        
        return recommsSectorData.filter(recommendation => 
            recommendation.name.toLowerCase().includes(searchValue.toLowerCase())
        );
    }, [recommsSectorData, searchValue]);

    const SectorsGrid = (
        <div className={styles.recomsGrid}>
            {filteredRecommendations.map((recommendation: Recommendation) => (
                <NewRecommendationCard
                    key={recommendation._id}
                    recommendation={recommendation}
                    handleLinkClick={goToRecommendations}
                    subUsersSectorData={subUsersSectorData}
                />
            ))}
        </div>
    );
    const breadcrumbsItems: BreadcrumbItem[] | undefined = [
        {
            label: "Субъекты",
            href: "/recommendations"
        },
        {
            label: "Рекомендации"
        }
    ]
    return (
        <>
            <PageHeader
                title={"Рекомендации"}
                isAdmin={isAdministrator(user)}
                enabledBackBtn={true}
                enabledBreadcrumbs={true}
                breadcrumbsItems={breadcrumbsItems}
                buttons={
                    <HeaderButtons
                        subUsersSectorData={subUsersSectorData}
                        searchValue={searchValue}
                        onSearchChange={setSearchValue}
                    />
                }
            />
            <LoadingErrorBlock
                isLoading={isLoading}
                isError={isError}
                errorMessage="Ошибка загрузки рекомендаций. Пожалуйста, попробуйте позже."
            />
            {(!isLoading && !isError && recommsSectorData !== undefined) && (
                <>
                    {filteredRecommendations.length > 0 ? SectorsGrid : (
                        <p>{searchValue.trim() ? 'Рекомендации не найдены' : 'Актуальных рекомендаций нет'}</p>
                    )}
                </>
            )}
        </>
    );
};

export default RecommendationsPageView;